import { CategoryDtoGroupNameEnum, CategoryDtoNameEnum, type CategoryDTO } from "api";

export interface TopStaffDTO {
  id: number;
  name: string;
  location: string;
  avatarUrl?: string;
  rating: number;
  coverImageUrl?: string;
  category: CategoryDTO;
}

const staff: TopStaffDTO[] = [
  {
    id: 1,
    name: "Sarah Johnson",
    location: "San Francisco, CA",
    avatarUrl: "https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-1.jpg",
    coverImageUrl: "https://storage.googleapis.com/uxpilot-auth.appspot.com/e4ca489733-ad86b08486ac194530ac.png",
    rating: 4,
    category: {
      id: 1,
      name: CategoryDtoNameEnum.BARBERS,
      groupName: CategoryDtoGroupNameEnum.BEAUTY,
    },
  },
  {
    id: 2,
    name: "Michael Torres",
    location: "San Francisco, CA",
    avatarUrl: "https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-3.jpg",
    coverImageUrl: "https://storage.googleapis.com/uxpilot-auth.appspot.com/fbf54d49ab-8a0e876dfd69242187bb.png",
    rating: 5,
    category: {
      id: 1,
      name: CategoryDtoNameEnum.BARBERS,
      groupName: CategoryDtoGroupNameEnum.BEAUTY,
    },
  },
  {
    id: 3,
    name: "Jessica Chen",
    location: "San Francisco, CA",
    avatarUrl: "https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-5.jpg",
    coverImageUrl: "https://storage.googleapis.com/uxpilot-auth.appspot.com/11d2a171f1-5a0377df3d68259fbed2.png",
    rating: 5,
    category: {
      id: 1,
      name: CategoryDtoNameEnum.BARBERS,
      groupName: CategoryDtoGroupNameEnum.BEAUTY,
    },
  },
];

export const useTopStaff = () => {
  return {
    loading: false,
    loaded: true,
    staff,
  };
};
